module.exports = __webpack_public_path__ + "static/screen-web-win-laptop@2x-3b163ae736f38f60650b562548f47da2.png";